/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
/* eslint-disable no-extra-boolean-cast */
/* -------------------------------------------------------------------------- */
/*                              Config                                        */
/* -------------------------------------------------------------------------- */

const configQueryMap = {
  'navbar-vertical-collapsed': 'INVENTORI_SUKAPURA_phoenixIsNavbarVerticalCollapsed',
  'color-scheme': 'INVENTORI_SUKAPURA_phoenixTheme',
  'navigation-type': 'INVENTORI_SUKAPURA_phoenixNavbarPosition',
  'vertical-navbar-appearance': 'INVENTORI_SUKAPURA_phoenixNavbarVerticalStyle',
  'horizontal-navbar-shape': 'INVENTORI_SUKAPURA_phoenixNavbarTopShape',
  'horizontal-navbar-appearance': 'INVENTORI_SUKAPURA_phoenixNavbarTopStyle'
};

const initialConfig = {
  INVENTORI_SUKAPURA_phoenixIsNavbarVerticalCollapsed: false,
  INVENTORI_SUKAPURA_phoenixTheme: 'light',
  INVENTORI_SUKAPURA_phoenixNavbarTopStyle: 'default',
  INVENTORI_SUKAPURA_phoenixNavbarVerticalStyle: 'default',
  INVENTORI_SUKAPURA_phoenixNavbarPosition: 'vertical',
  INVENTORI_SUKAPURA_phoenixNavbarTopShape: 'default',
  INVENTORI_SUKAPURA_phoenixIsRTL: false,
  INVENTORI_SUKAPURA_phoenixSupportChat: true
};

const CONFIG = { ...initialConfig };

const setConfig = (payload, persist = true) => {
  Object.keys(payload).forEach(key => {
    CONFIG[key] = payload[key];
    if (persist) {
      localStorage.setItem(key, payload[key]);
    }
  });
};

const resetConfig = () => {
  Object.keys(initialConfig).forEach(key => {
    CONFIG[key] = initialConfig[key];
    localStorage.setItem(key, initialConfig[key]);
  });
};

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

if (
  Object.keys(params).length > 0 &&
  Object.keys(params).includes('theme-control')
) {
  resetConfig();

  Object.keys(params).forEach(param => {
    if (configQueryMap[param]) {
      localStorage.setItem(configQueryMap[param], params[param]);
    }
  });
}

Object.keys(CONFIG).forEach(key => {
  if (localStorage.getItem(key) === null) {
    localStorage.setItem(key, CONFIG[key]);
  } else {
    try {
      setConfig({
        [key]: JSON.parse(localStorage.getItem(key))
      });
    } catch {
      setConfig({
        [key]: localStorage.getItem(key)
      });
    }
  }
});

if (!!JSON.parse(localStorage.getItem('INVENTORI_SUKAPURA_phoenixIsNavbarVerticalCollapsed'))) {
  document.documentElement.classList.add('navbar-vertical-collapsed');
}

if (localStorage.getItem('INVENTORI_SUKAPURA_phoenixTheme') === 'dark') {
  document.documentElement.setAttribute('data-bs-theme', 'dark');
} else if (localStorage.getItem('INVENTORI_SUKAPURA_phoenixTheme') === 'auto') {
  document.documentElement.setAttribute(
    'data-bs-theme',
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );
}

if (localStorage.getItem('INVENTORI_SUKAPURA_phoenixNavbarPosition') === 'horizontal') {
  document.documentElement.setAttribute('data-navigation-type', 'horizontal');
}

if (localStorage.getItem('INVENTORI_SUKAPURA_phoenixNavbarPosition') === 'combo') {
  document.documentElement.setAttribute('data-navigation-type', 'combo');
}

export default {
  config: CONFIG,
  reset: resetConfig,
  set: setConfig
};
